import { render, staticRenderFns } from "./DuplicateLessonProperties.vue?vue&type=template&id=01499430&scoped=true&"
import script from "./DuplicateLessonProperties.vue?vue&type=script&lang=js&"
export * from "./DuplicateLessonProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01499430",
  null
  
)

export default component.exports